import feedbackWatch from '../../shared/articleFeedback/_articleFeedback';

feedbackWatch();
